namespace advisorop.components.identity {

    /// Shown when one Salesforce identity belongs to more than one login here - the same person
    /// holding, say, an advisor login and a servicer login on one email address.
    ///
    /// Nothing is signed in when this screen appears. The server has authenticated the Salesforce
    /// user and resolved the candidates, but it issued only a short-lived selection ticket; the
    /// session is established when a choice comes back. The references below are opaque and mean
    /// nothing outside that ticket, so this screen cannot be used to ask for some other account.
    class SsoAccountChooserController {

        $router;

        choices: domains.identity.ISsoAccountChoice[] = [];
        nonce: string;

        loading = true;
        submitting = false;

        constructor(private identityService: services.IdentityService) {
        }

        $routerOnActivate(next, previous) {
            this.identityService.getSsoChoices()
                .then((response: any) => {
                    this.nonce = response.data.nonce;
                    this.choices = response.data.choices || [];

                    if (this.choices.length === 0) {
                        this.backToLogin("nolink");
                    }
                }, (resp: any) => {
                    // The ticket is gone or was never there - most often because the three minutes
                    // ran out while the screen sat open.
                    this.backToLogin(resp && resp.data ? resp.data : "expired");
                }).finally(() => {
                    this.loading = false;
                });
        }

        choose(choice: domains.identity.ISsoAccountChoice): void {
            if (this.submitting) {
                return;
            }

            this.submitting = true;

            this.identityService.selectSsoAccount(choice.reference, this.nonce)
                .then((response: any) => {
                    // A full navigation rather than a route change: the session cookie has just
                    // changed, and the server decides where this login belongs.
                    window.location.href = response.data && response.data.redirectTo
                        ? response.data.redirectTo
                        : "/";
                }, (resp: any) => {
                    this.submitting = false;
                    this.backToLogin(resp && resp.data ? resp.data : "failed");
                });
        }

        backToLogin(reason?: string): void {
            window.location.href = reason
                ? "/identity/login?ssoerror=" + encodeURIComponent(reason)
                : "/identity/login";
        }
    }

    class SsoAccountChooser implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                $router: '<'
            };
            this.controller = ["identityService", SsoAccountChooserController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/sso-account-chooser.html';
        }
    }

    angular.module(Constants.APP).component("ssoAccountChooser", new SsoAccountChooser());
}
